// extracted by mini-css-extract-plugin
export default {"option":"MultipleChoiceSettings_option__qkHtG","icon":"MultipleChoiceSettings_icon__PJEKu","input":"MultipleChoiceSettings_input__6LOAO"};